"use strict";

define('libs/route.helper',['backbone', 'underscore', 'handlebars', '../config', 'appkit/router'], function (Backbone, _, Handlebars, config, E3Router) {
  var RouteHelper = Backbone.Model.extend({
    constructor: function constructor(routeName) {
      this.routeName = routeName;
      this.attributes = {};
      this.changed = {};
      this.ignoredKeys = [];
      this.models = [];
      _.each(_.rest(arguments), this.add, this);
      this.updateLink();
    },
    removeAll: function removeAll() {
      var models = _.clone(this.models);
      for (var i = 0, len = models.length, model; i < len; i++) {
        model = models[i];
        this.stopListening(model.model);
      }
      this.models = [];
      this.updateLink();
      return this;
    },
    add: function add(model, mapping) {
      model = model instanceof Backbone.Model ? model : new Backbone.Model(model);
      this.models.push({
        model: model,
        mapping: mapping
      });
      this.listenTo(model, 'change', this.updateLink);
      this.updateLink();
      return this;
    },
    ignore: function ignore(key) {
      this.ignoredKeys.push(key);
      this.updateLink();
      return this;
    },
    updateLink: function updateLink() {
      var params = {};
      _.each(this.models, function (item) {
        if (item.mapping) {
          _.each(item.mapping, function (src, dest) {
            params[dest] = item.model.get(src);
          });
        } else {
          _.extend(params, item.model.toJSON());
        }
      });
      this.set('link', this.constructor.resolve(this.routeName, _.omit(params, this.ignoredKeys)));
      return this;
    }
  }, {
    linkFormatGenerator: function linkFormatGenerator(routeName, mapping) {
      return function (model) {
        var routeHelper = new RouteHelper(routeName).add(model, mapping);
        return routeHelper.get('link');
      };
    },
    createLink: function createLink(routeName, model, mapping) {
      var routeHelper = new RouteHelper(routeName).add(model, mapping);
      return routeHelper.get('link');
    }
  });
  RouteHelper.map = {};
  RouteHelper.defaltParams = {};
  RouteHelper.setDefaultParams = function (name, params) {
    RouteHelper.defaltParams[name] = _.extend({}, RouteHelper.defaltParams[name], params);
    return this;
  };
  RouteHelper.getDefaultParams = function (name) {
    return _.extend({}, RouteHelper.defaltParams[name]);
  };
  RouteHelper.resolve = function (name, params) {
    var router = this.map[name];
    var root = config.usePushState ? config.staticRoot + '/' : '#';
    if (router instanceof E3Router) {
      return root + router.resolve(name, _.extend(RouteHelper.getDefaultParams(name), params));
    }
    return root;
  };
  RouteHelper.register = function (router) {
    if (router instanceof E3Router) {
      _.map(router._routeNames, function (route, name) {
        this.map[name] = router;
      }, this);
    }
  };
  Handlebars.registerHelper('routeLink', function (name) {
    return '#' + RouteHelper.resolve(name);
  });
  return RouteHelper;
});

